import { Box, TableCell, TableCellProps } from '@mui/material'
import { comparer } from 'mobx'
import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'
import { getImageSrc } from '../../helpers/getImageSrc'

type TableHeaderCellProps = TableCellProps &
  PropsWithChildren & {
    propKey?: string
    paddingLeftKeys?: string[]
    width?: string
    onSort?: () => void
    sort?: string
    sortKey?: string
    customPadding?: string
  }

const TableHeaderCell: FC<TableHeaderCellProps> = ({
  children,
  propKey,
  paddingLeftKeys = [],
  width,
  onSort,
  sort,
  sortKey,
  customPadding,
  ...otherProps
}) => {
  const isActiveSort = sort?.endsWith(sortKey?.toLowerCase() ?? '-')
  const isReverse =
    isActiveSort && !comparer.default(sort, sortKey?.toLowerCase())

  return (
    <TableCell
      className={'fx-nowrap'}
      sx={{
        background: '#fff',
        color: '#A9A9A9',
        transition: '.3s ease',
        transitionProperty: 'color, opacity',
        height: '54px',
        padding: customPadding || '4px',
        paddingLeft: paddingLeftKeys.includes(propKey ?? '')
          ? '20px!important'
          : customPadding || '4px',
        cursor: onSort ? 'pointer' : 'default',
        width,

        img: {
          opacity: isActiveSort ? 1 : '.5',
        },
        '&:hover': {
          color: onSort ? '#5F5F5F' : '#A9A9A9',
          img: {
            opacity: 1,
          },
        },
      }}
      onClick={onSort}
      {...otherProps}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {children}
        {onSort && (
          <img
            src={getImageSrc('table-arrow')}
            style={{
              marginLeft: '4px',

              transform:
                isReverse || !isActiveSort ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        )}
      </Box>
    </TableCell>
  )
}

export default observer(TableHeaderCell)
